import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReorderOrderService } from '@spartacus/order/core';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';
import { OrderStatusService } from 'src/app/services/feature/orderStatus/order-status.service';
import moment from 'moment';
import { CartActions, StateWithMultiCart } from '@spartacus/cart/base/core';
import { Store } from '@ngrx/store';
import { OrderTrackingStatusPopupComponent } from '../order-tracking-status-popup/order-tracking-status-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, take } from 'rxjs';
import { RoutingService, UserIdService } from '@spartacus/core';
import { MultiCartFacade } from '@spartacus/cart/base/root';
@Component({
  selector: 'app-order-status-details',
  templateUrl: './order-status-details.component.html',
  styleUrls: ['./order-status-details.component.scss'],
  standalone: false
})
export class OrderStatusDetailsComponent {
  orderDetails: any;
  statusDate: any;
  isPosition: boolean = false;

  fleetPrideGroup: any;
  showCorePrice$ = this.custIDService.showCorePrice$;
  showNetPrice$ = this.custIDService.showNetPrice$;
  dialog = inject(MatDialog);
  subscription = new Subscription();
  constructor(
    public orderStatusService: OrderStatusService,
    private activateRoute: ActivatedRoute,
    public custIDService: CustomerIdService, private cdr: ChangeDetectorRef,
    private router: Router,
    private reorderOrderService: ReorderOrderService,
    protected store: Store<StateWithMultiCart>,
    private multiCartService: MultiCartFacade,
    private routingService: RoutingService,
    private userIdService: UserIdService,
  ) { }
  ngOnInit() {
    const params = this.activateRoute.snapshot.queryParams;
    if (params['orderId']) {
      this.subscription.add(this.orderStatusService.getOrderStatusDetails(params['orderId']).subscribe((data: any) => {
        this.orderDetails = data?.orderDetails;
        this.cdr.detectChanges();
      }));
    }
    this.statusDate = new Date();

    this.subscription.add(this.custIDService.fleetPrideGroup$.subscribe(x => {
      this.fleetPrideGroup = x;
      this.cdr.detectChanges();
    }));
  }

  formatDate(dateString: any, format: string): string {
    if (dateString) {
      const date = new Date(dateString);

      return moment(date).format(format.toUpperCase());
    }
    return '';
  }

  padZero(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }

  reorder() {
    this.subscription.add(this.orderStatusService.reorder(this.orderDetails.hybrisOrderNumber).subscribe((res: any) => {
      /* this.store.dispatch(new CartActions.SetActiveCartId(res.cartId));
      this.router.navigate(['cart']); */
      const cartId = res?.cartId;
      this.store.dispatch(new CartActions.SetActiveCartId(cartId))
      if (!cartId) {
        return;
      }
      this.routingService.go({ cxRoute: 'cart' });
      this.userIdService.takeUserId().pipe(take(1)).subscribe(userId => {
        this.multiCartService.loadCart({
          userId,
          cartId,
          extraData: { active: true },
        });
      });
    }));
  }

  backToHistory() {
    this.router.navigate(['orders']);
  }

  backToOpenPosition() {
    this.router.navigate(['open-positions']);
  }
  shouldShowCoreDeposit(entryNumber: number, posType: string): boolean {
    return entryNumber % 10 !== 0 && posType === 'KI';
  }
  openDialog() {
    this.dialog.open(OrderTrackingStatusPopupComponent, {
      data: {
        orderDetails: this.orderDetails,
      },
    });
  }
  hasTrackingNumber(orderDetails: any) {
    for (const entry of orderDetails.entries) {
      for (const scheduleLines of entry.scheduleLines) {
        if (scheduleLines.trackingNumber) {
          return false;
        }
      }
    }
    return true;
  }
}
